export interface VisibilityObserverElement {
	visibilityChanged: (visible: boolean) => void;
}

export const visibilityObserver = new IntersectionObserver(
	(entries, observer) => {
		requestAnimationFrame(() => {
			for (const entry of entries) {
				const $target = entry.target as any as VisibilityObserverElement;
				$target.visibilityChanged?.(entry.isIntersecting);
			}
		});
	},
	{
		//root: document.documentElement,
		rootMargin: "-100px"
		//threshold: [0, 1]
	}
);
